export * from "./contexts";
export * from "./scheduler";
export * from "./types";
export * from "./user-agent";

export const safeSetLocalStorage = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch {}
};

export function findFirstNonEmptyString(...values: (null | string | undefined)[]) {
  return values.find(value => value?.length ?? 0 > 0)?.trim() ?? "";
}

export function getIsInWebView() {
  // ref: https://github.com/atomantic/is-ua-webview/blob/main/data/rules.js
  const webViewRegex = new RegExp(
    "(" +
      [
        "WebView",
        "(iPhone|iPod|iPad)(?!.*Safari)",
        String.raw`Android.*(;\s+wv|Version/\d.\d\s+Chrome/\d+(\.0){3})`,
        "Linux; U; Android",
      ].join("|") +
      ")",
    "ig",
  );
  const userAgent = getUserAgent();
  return webViewRegex.test(userAgent);
}

/**
 * As theme.breakpoints.up("desktop") will return @media (min-width:1024px), we need to remove the @media manually
 */
export function removeAtMedia(breakpointString: string) {
  return breakpointString.replaceAll("@media", "").trim();
}

export function safeJsonParse<T>(value: null | string | undefined): T {
  try {
    return value ? (JSON.parse(value) as T) : ({} as T);
  } catch {
    return {} as T;
  }
}

export function unionArray<T>(...arrays: T[][]) {
  const set = new Set();
  return [...arrays].flat().filter(key => (set.has(key) ? false : set.add(key)));
}

// ref: https://github.com/gr2m/universal-user-agent/blob/master/index.js
function getUserAgent() {
  if (typeof navigator === "object" && "userAgent" in navigator) {
    return navigator.userAgent;
  }

  if (typeof process === "object" && process.version !== undefined) {
    return `Node.js/${process.version.slice(1)} (${process.platform}; ${process.arch})`;
  }

  return "<environment undetectable>";
}
